import { StreamRoleId } from '@mimir/common/dto/mediaAvailability';
import type { StreamSetPreference } from '@mimir/common/dto/mediaDtos';

const browsePreviewCmafSplitStream: StreamRoleId[] = [
  StreamRoleId.BrowsePreviewVideo,
  StreamRoleId.BrowsePreviewAudioDownmix
];

const browsePreviewCmafMultiStream: StreamRoleId[] = [
  StreamRoleId.BrowsePreviewVideoAudioDownMix
];

const browsePreviewTsStreams: StreamRoleId[] = [
  StreamRoleId.LiveRecordWebproxyTs
];

const highresTsStreams: StreamRoleId[] = [
  StreamRoleId.LiveRecordHighresTs
];

const browsePreviewAudioTsStreams: StreamRoleId[] = [
  StreamRoleId.LiveRecordAudioOnlyProxyTs,
];

const highresAudioTsStreams: StreamRoleId[] = [
  StreamRoleId.LiveRecordAudioOnlyHighresTs,
];

export const preferLowBandwidth: StreamSetPreference = [
  browsePreviewTsStreams,
  browsePreviewCmafSplitStream,
  browsePreviewCmafMultiStream,
  highresTsStreams,
  browsePreviewAudioTsStreams,
  highresAudioTsStreams,
];

export const preferQuality: StreamSetPreference = [
  highresTsStreams,
  browsePreviewTsStreams,
  browsePreviewCmafSplitStream,
  browsePreviewCmafMultiStream,
  highresAudioTsStreams,
  browsePreviewAudioTsStreams,
];
